<div class="page-header">
  @if (backLabel()) {
    <div class="page-header__back hidden-xs" data-testid="page-header-back-btn" (click)="onBackClicked()">
      <lt-icon name="fa-sharp-solid-long-arrow-left" class="page-header__back-icon mara-blue"></lt-icon>

      <span class="page-header__back-link f5 mara-blue">
        {{ backLabel() | ltTranslate }}
      </span>
    </div>
  }

  <div class="page-header__content">
    <div class="page-header__left">
      <h1 class="page-header__title mara-blue">
        {{ headerKey() | ltTranslate }}
      </h1>

      @if (descKey()) {
        <h3 class="page-header__subtitle" [ngClass]="subtitleClass()">
          {{ descKey() | ltTranslate }}
        </h3>
      }
    </div>

    <div class="page-header__right">
      <ng-content></ng-content>
    </div>
  </div>
</div>
